import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import api from "./api.js"
import OssUtils from './utils/oss.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Button, Dialog, Message, MessageBox, Icon } from 'element-ui'
import * as echarts from 'echarts'


Vue.config.productionTip = false;

// 全局变量
window.__GLOBAL_STS_CREDENTIAL__ = null
export const EventBus = new Vue()
Vue.prototype.$bus = EventBus
// ✅ 异步等待凭证（不会再 null 了）
Vue.prototype.$stsCredential = async function () {
  let retry = 0
  while (retry < 30) {
    if (window.__GLOBAL_STS_CREDENTIAL__) {
      return window.__GLOBAL_STS_CREDENTIAL__
    }
    await new Promise(r => setTimeout(r, 200))
    retry++
  }
  return null
}

Vue.use(Button);
Vue.use(Dialog);
Vue.use(Icon);
Vue.use(ElementUI);
Vue.use(OssUtils)
Vue.prototype.$echarts = echarts
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.API = api;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');